import React from 'react'
import negate from 'lodash/negate'
import cloneDeep from 'lodash/cloneDeep'

// @ts-ignore
import FormField, { FormLayout } from 'shared/newFormElements'
// @ts-ignore
import withLookups, { LookupType } from 'shared/containers/withLookups'

import { isRequired } from '../../helpers'
import translate from '../translate'
import { ThirdPageWrapper } from './styles'

const isVisible = (item) => item.isVisible
const isInvisible = negate(isVisible)

const createItemMapper = (noVisibilityFilter, fields) => (item) => {
  return {
    ...item,
    visible: noVisibilityFilter || Boolean(fields[item.name]),
    required: isRequired(fields[item.name]),
  }
}

const Selects = ({ items }) => (
  <div className="client-form__third-page__selects">
    {[...items.filter(isVisible), ...items.filter(isInvisible)].map(({ name, label, visible, ...attrs }, index) => (
      <FormLayout key={name} label={translate(label)} visible={visible} labelFieldProportions="7:9" autoHeight>
        <FormField {...attrs} type={attrs.type || 'select'} name={name} openOnFocus={false} search />
      </FormLayout>
    ))}
  </div>
)

const LeftSelects = ({ noVisibilityFilter, selects, lookups, fields }) => {
  const items = [
    {
      label: 'lbl_marital_status',
      name: 'IND_MaritalStatusID',
      options: selects.Maritalstatus,
    },
    {
      label: 'lbl_education',
      name: 'IND_EducationID',
      options: selects.Education,
    },
    {
      label: 'lbl_idp_t',
      name: 'IND_IDP',
      options: selects.IDP,
    },
    {
      label: 'lbl_resident_t',
      name: 'IND_Resident',
      options: selects.Resident,
    },
    {
      label: 'lbl_nationality',
      name: 'IND_NationalityID',
      options: selects.Nationality,
    },
    {
      label: 'lbl_citizenship',
      name: 'CitizenshipID',
      options: selects.Citizenship,
      searchable: true,
    },
    {
      label: 'lbl_citizenship2_t',
      name: 'Citizenship2ID',
      options: selects.Citizenship,
    },
    {
      label: 'lbl_native_lang',
      name: 'IND_LanguagesID',
      options: selects.Language,
    },
    {
      label: 'lbl_health_status',
      name: 'IND_HealthID',
      options: selects.Health,
    },
    {
      label: 'lbl_religion',
      name: 'ReligionID',
      options: selects.Religion,
    },
    {
      label: 'lbl_race',
      options: selects.Race,
      name: 'RaceID',
    },
    {
      label: 'lbl_caste',
      name: 'CasteID',
      options: selects.Caste,
    },
    {
      label: 'lbl_smspref',
      name: 'SMSPrefID',
      options: selects.SMSPref,
    },
    {
      label: 'lbl_emailpref_t',
      name: 'EmailPrefID',
      options: selects.EmailPref,
    },
    {
      label: 'lbl_statuslevel_t',
      name: 'StatusLevelID',
      options: selects.StatusLevel,
    },
    {
      label: 'lbl_pepflag_t',
      name: 'PEPFlag',
      options: lookups.LKP_YesNo,
    },
    {
      label: 'lbl_amlstatus',
      name: 'AMLStatusID',
      options: selects.AMLStatus,
    },
    {
      label: 'lbl_amlindustry',
      name: 'AMLIndustryID',
      options: selects.AMLIndustry,
    },
    {
      label: 'lbl_amlsuspicious',
      name: 'AMLSuspiciousID',
      options: selects.AMLSuspicious,
    },
  ].map(createItemMapper(noVisibilityFilter, fields))

  return <Selects items={items} />
}

const RightSelects = ({ noVisibilityFilter, selects, lookups, fields }) => {
  const items = [
    {
      label: 'lbl_employment',
      name: 'IND_JobStatusID',
      options: selects.Jobstatus,
    },
    {
      label: 'lbl_job_pos',
      name: 'IND_JobPositionID',
      options: selects.Jobposition,
    },
    {
      label: 'lbl_Profession',
      name: 'IND_ProfessionID',
      options: selects.Jobposition,
      type: 'text',
      maxLength: fields.IND_ProfessionID ? fields.IND_ProfessionID.MaxLen : -1,
    },
    { label: 'lbl_monthly_income', name: 'IND_IncomeID', options: selects.Income },
    {
      label: 'lbl_monthly_expences',
      name: 'IND_ExpencesID',
      options: selects.Expences,
    },
    { label: 'lbl_dwelling', name: 'IND_DwellingID', options: selects.Dwelling },
    { label: 'lbl_insider_t', name: 'IND_Insider', options: selects.Insider },
    { label: 'lbl_land', name: 'IND_LandID', options: selects.Land },
    {
      label: 'lbl_node',
      name: 'NodeID',
      options: lookups.Nodes.filter((node) => node.ID !== 0),
    },
    { label: 'lbl_eng_t', name: 'IND_EnglishKnowledge', options: selects.English },
    { label: 'lbl_reading_t', name: 'IND_ReadingSkills', options: selects.Reading },
    { label: 'lbl_mcl_t', name: 'MCLEnabled', options: selects.MCLEnabled },
    { label: 'lbl_sdaenabled', name: 'SDAEnabled', options: selects.SDAEnabled },
    { label: 'lbl_kyc_t', name: 'KYCValidityID', options: selects.KYCValidity },
    {
      label: 'lbl_autocoverpref_t',
      name: 'AutoCoverPrefID',
      options: selects.AutoCoverPref,
    },
    {
      label: 'lbl_clientnotclient_t',
      name: 'ClientNotClientFlag',
      options: lookups.LKP_YesNo,
    },
    {
      label: 'lbl_specialneedsflag',
      name: 'SpecialNeedsFlag',
      options: selects.SpecialNeeds,
    },
    { label: 'lbl_smssignflag', name: 'SMSSignFlag', options: selects.SMSSign },
  ].map(createItemMapper(noVisibilityFilter, fields))

  return <Selects items={items} />
}

// TODO: auto focus first item. Before FormField was wrapped with SemanticDropdownAutoFocus
const ThirdPage = ({ fields, selects, lookups, noVisibilityFilter }) => {
  const _fields = React.useMemo(() => {
    const result = cloneDeep(fields)

    return result
  }, [fields])

  return (
    <ThirdPageWrapper>
      <LeftSelects noVisibilityFilter={noVisibilityFilter} selects={selects} lookups={lookups} fields={_fields} />
      <RightSelects noVisibilityFilter={noVisibilityFilter} selects={selects} lookups={lookups} fields={_fields} />
    </ThirdPageWrapper>
  )
}

export default withLookups({
  type: LookupType.System,
  query: '* as lookups',
})(ThirdPage)
